module.exports = __webpack_public_path__ + "static/media/22-web-or-mls-DSC06435.162aa2c5.jpg";